<template>
    <form
        id="password"
        action=""
        class="cabinet-settings supplier-tab hide"
        data-title="Пароль"
        @submit.prevent="onUpdatePassword"
    >
        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="cpassword"
                >Текущий пароль</label
            >
            <input
                id="cpassword"
                v-model="old_password"
                type="password"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.old_password.$dirty && $v.old_password.$invalid) ||
                        errors.updatePassword.old_password
                }"
            />
            <div
                v-if="$v.old_password.$dirty && $v.old_password.$invalid"
                class="error-label"
            >
                Поле обязательно для заполнения
            </div>
            <div v-if="errors.updatePassword.old_password" class="error-label">
                {{ errors.updatePassword.old_password[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="npassword"
                >Новый пароль</label
            >
            <input
                id="npassword"
                v-model="password"
                type="password"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.password.$dirty && $v.password.$invalid) ||
                        errors.updatePassword.password
                }"
            />
            <div
                v-if="$v.password.$dirty && $v.password.$invalid"
                class="error-label"
            >
                Поле обязательно для заполнения
            </div>
            <div v-if="errors.updatePassword.password" class="error-label">
                {{ errors.updatePassword.password[0] }}
            </div>
        </div>

        <div class="cabinet-form-group">
            <label class="cabinet-form-group__label required" for="rpassword"
                >Подтвердите новый пароль</label
            >
            <input
                id="rpassword"
                v-model="rpassword"
                type="password"
                class="cabinet-form-group__input"
                :class="{
                    error:
                        ($v.rpassword.$dirty && $v.rpassword.$invalid) ||
                        errors.updatePassword.rpassword
                }"
            />
            <div
                v-if="$v.rpassword.$dirty && $v.rpassword.$invalid"
                class="error-label"
            >
                Пароли не совпадают
            </div>
            <div v-if="errors.updatePassword.rpassword" class="error-label">
                {{ errors.updatePassword.rpassword[0] }}
            </div>
        </div>

        <div class="product-form__btn-wrap">
            <button
                type="submit"
                class="cabinet-btn product-form__btn"
                :class="{ loading: loading }"
                :disabled="loading"
            >
                Изменить пароль
            </button>
        </div>
    </form>
</template>

<script>
import { required, minLength, sameAs, not } from 'vuelidate/lib/validators'
import checkDemoUser from '@/mixins/checkDemoUser.js'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'RetailerPassword',
    mixins: [checkDemoUser],
    data() {
        return {
            old_password: '',
            password: '',
            rpassword: '',
            loading: false
        }
    },
    validations: {
        old_password: {
            required
        },
        password: {
            required,
            notSameAsOldP: not(sameAs('old_password'))
        },
        rpassword: {
            required,
            sameAsP: sameAs('password')
        }
    },
    computed: {
        ...mapState('user', ['user', 'errors'])
    },
    methods: {
        ...mapActions('user', ['updatePassword']),
        async onUpdatePassword() {
            if (this.loading) return

            if (this.isDemoUserMode()) return

            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.loading = true

                let data = await this.updatePassword({
                    old_password: this.old_password,
                    password: this.password,
                    rpassword: this.rpassword
                })

                console.log()

                if (data && data.success) {
                    this.old_password = ''
                    this.password = ''
                    this.rpassword = ''

                    this.$v.$reset()
                    this.$notify({
                        title: 'Пароль',
                        type: 'success',
                        text: 'Успешно изменен'
                    })
                }

                this.loading = false
            } else {
                console.log('Form not valid')
            }
        }
    }
}
</script>
